.wrapper {
  flex-direction: column;

  .content {
    height: 100%;
  }

  .loader {
    display: none;
  }

  &.is-loading {
    .loader {
      display: block;
      padding-top: var(--spacer);
    }
    .content {
      display: none;
    }
  }
}

.accordion-slot {
  display: inline-flex;
}
.panel-title {
  margin-bottom: calc(4 * var(--spacer));
}
.d-none {
  display: none;
}


.section-title {
  color: var(--chart-300-icon-buttons);
  min-height: calc(4 * var(--spacer));
  line-height: 1.5;
  padding: var(--spacer) calc(2 * var(--spacer));
}

.section-title {
  margin-top: var(--spacer);
}

.smart-list {
  margin-top: var(--spacer);
  margin-bottom: var(--spacer);
  position: relative;

  &:not(:first-of-type) {
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      height: 1px;
      width: calc(100% - calc(5 * var(--spacer)));
      left: calc(3 * var(--spacer));
      background-color: var(--chart-101-pressed-dividers);
    }
  }
}

.accordion-count {
  padding-left: calc(var(--spacer) / 2);
}

.panel-content {
  flex: 2;
}

gz-list-item {
  padding: 0;
}

gz-accordion {
  padding-top: 0;
  --margin--compact-accordion: 0;
}
